import type {XeroPnLMeta} from "@hooks/use-vnext";

interface XeroPnlHeaderProps {
    meta: XeroPnLMeta;
    inverted?: boolean;
}

export function XeroPnlHeader({meta, inverted = false}: XeroPnlHeaderProps) {
    const generatedAt = meta.generated_at
        ? new Date(meta.generated_at).toLocaleString()
        : "";

    return (
        <div className="flex items-end justify-between">
            <div>
                <h2 className={`text-xl font-bold ${inverted ? "text-white" : "text-[#209DB3]"}`}>
                    {meta.workspace_name}
                </h2>
                <p className={`text-sm mt-0.5 ${inverted ? "text-white/85" : "text-muted-foreground"}`}>
                    {meta.period_label}
                    {meta.scenario_name && meta.scenario_name !== "Base" && (
                        <span className="ml-2 text-xs">({meta.scenario_name})</span>
                    )}
                </p>
            </div>
            <div className={`text-right text-xs ${inverted ? "text-white/80" : "text-muted-foreground"}`}>
                <p>
                    {meta.n_actual_months} actual + {meta.n_forecast_months} forecast months
                </p>
                {generatedAt && <p>As of {generatedAt}</p>}
            </div>
        </div>
    );
}
